"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAD_CLICK_ID_TYPES = exports.LEAD_EVENT_ALIASES = exports.CHECKER_SCHEDULE_STEP = exports.LEAD_EVENT_MAX_BYTES = exports.LEAD_EVENT_BATCH_MAX = exports.LEAD_WEB_EVENT_TYPES = exports.LEAD_EVENT_TYPES = void 0;
exports.isKnownLeadEventType = isKnownLeadEventType;
exports.isWebLeadEventType = isWebLeadEventType;
/**
 * Event taxonomy v1 (TRD §14.2, including the v5 rows).
 *
 * Props are camelCase, matching the public JSON samples in §10. Only props the TRD
 * names are typed, plus `gate_submitted.keyCollection` (HAN-696). Every other type
 * accepts an empty `props` object so a later ticket can add fields without renaming the type.
 *
 * Pairs in `LEAD_EVENT_ALIASES` are the same action. Emit one side, not both.
 * `id_invite_submitted` is the name §10.5 and the Slack alert table use;
 * §14.2 calls that action `invite_submitted`.
 */
exports.LEAD_EVENT_TYPES = [
    "page_view",
    "tool_viewed",
    "tool_started",
    "tool_step_completed",
    "preview_shown",
    "gate_viewed",
    "gate_field_error",
    "gate_submitted",
    "result_viewed",
    "pdf_downloaded",
    "cta_clicked",
    "match_requested",
    "whatsapp_clicked",
    "answer_given",
    "note_added",
    "id_added",
    "invite_sheet_opened",
    "invite_option_picked",
    "invite_submitted",
    "id_invite_submitted",
    "send_it_myself_tapped",
    "report_viewed",
    "comparison_viewed",
    "send_again_tapped",
    "own_terms_applied",
    "schedule_submitted",
    "faq_opened",
    "how_scored_opened",
    "show_all_criteria_tapped",
    "question_back_tapped",
    "next_id_started",
    "skip_id_tapped",
    "resume_shown",
    "resume_continued",
    "resume_restarted",
    "gate_stage_picked",
    "gate_opt_in_ticked",
    "gate_submit_failed",
    "jump_link_tapped",
    "question_copied",
    "message_copied",
    "score_breakdown_opened",
    "id_switched",
    "view_full_report_tapped",
    "send_comparison_tapped",
    "back_to_report_tapped",
    "see_how_protected_tapped",
    "check_another_tapped",
    "score_another_tapped",
    "walkthrough_started",
    "walkthrough_finished",
    "invite_form_error",
    "id_ref_visit",
    "lead_created",
    "lead_updated",
    "consent_granted",
    "consent_revoked",
    "opt_out_applied",
    "pdf_rendered",
    "pdf_render_failed",
    "message_queued",
    "message_suppressed",
    "message_sent",
    "message_failed",
    "dd_requested",
    "dd_report_uploaded",
    "dd_report_published",
    "dd_report_sent",
    "dd_send_failed",
    "dd_report_withdrawn",
    "dd_cap_reached",
    "alert_sent",
    "alert_suppressed",
    "link_clicked",
];
/**
 * Types the browser may send on `POST /public/events` (TRD §14.2 client rows).
 * Server-fact types (`lead_created`, delivery, DD reports, alerts, `dd_requested`)
 * stay off this list so they can only be written with `source: "system"` / `"team"`.
 */
exports.LEAD_WEB_EVENT_TYPES = [
    "page_view",
    "tool_viewed",
    "tool_started",
    "tool_step_completed",
    "preview_shown",
    "gate_viewed",
    "gate_field_error",
    "gate_submitted",
    "result_viewed",
    "pdf_downloaded",
    "cta_clicked",
    "match_requested",
    "whatsapp_clicked",
    "answer_given",
    "note_added",
    "id_added",
    "invite_sheet_opened",
    "invite_option_picked",
    "invite_submitted",
    "id_invite_submitted",
    "send_it_myself_tapped",
    "report_viewed",
    "comparison_viewed",
    "send_again_tapped",
    "own_terms_applied",
    "schedule_submitted",
    "faq_opened",
    "how_scored_opened",
    "show_all_criteria_tapped",
    "question_back_tapped",
    "next_id_started",
    "skip_id_tapped",
    "resume_shown",
    "resume_continued",
    "resume_restarted",
    "gate_stage_picked",
    "gate_opt_in_ticked",
    "gate_submit_failed",
    "jump_link_tapped",
    "question_copied",
    "message_copied",
    "score_breakdown_opened",
    "id_switched",
    "view_full_report_tapped",
    "send_comparison_tapped",
    "back_to_report_tapped",
    "see_how_protected_tapped",
    "check_another_tapped",
    "score_another_tapped",
    "walkthrough_started",
    "walkthrough_finished",
    "invite_form_error",
    "id_ref_visit",
    "link_clicked",
];
/** §10.1: at most this many events per ingest, and at most 8 KB of props each. */
exports.LEAD_EVENT_BATCH_MAX = 20;
exports.LEAD_EVENT_MAX_BYTES = 8 * 1024;
/** `tool_step_completed.props.step` value that `schedule_submitted` aliases. */
exports.CHECKER_SCHEDULE_STEP = "schedule";
exports.LEAD_EVENT_ALIASES = {
    report_viewed: "result_viewed",
    schedule_submitted: "tool_step_completed",
    id_invite_submitted: "invite_submitted",
};
/** Click ids named on the ingest payload (TRD §10.1). */
exports.LEAD_CLICK_ID_TYPES = ["gclid", "fbclid", "ttclid"];
const LEAD_EVENT_TYPE_SET = new Set(exports.LEAD_EVENT_TYPES);
const LEAD_WEB_EVENT_TYPE_SET = new Set(exports.LEAD_WEB_EVENT_TYPES);
function isKnownLeadEventType(type) {
    return LEAD_EVENT_TYPE_SET.has(type);
}
function isWebLeadEventType(type) {
    return LEAD_WEB_EVENT_TYPE_SET.has(type);
}
